"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemApiRoomWallPlatform = exports.StreemApiRoomVideoPlatform = exports.StreemApiRoomStatus = exports.StreemApiRoomPreferredVideoCodec = exports.StreemApiRoomToJSON = exports.StreemApiRoomFromJSONTyped = exports.StreemApiRoomFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function StreemApiRoomFromJSON(json) {
    return StreemApiRoomFromJSONTyped(json, false);
}
exports.StreemApiRoomFromJSON = StreemApiRoomFromJSON;
function StreemApiRoomFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !(0, runtime_1.exists)(json, 'sid') ? undefined : json['sid'],
        'createdByUserSid': !(0, runtime_1.exists)(json, 'created_by_user_sid') ? undefined : json['created_by_user_sid'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'openedAt': !(0, runtime_1.exists)(json, 'opened_at') ? undefined : (new Date(json['opened_at'])),
        'preferredVideoCodec': !(0, runtime_1.exists)(json, 'preferred_video_codec') ? undefined : json['preferred_video_codec'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'closedAt': !(0, runtime_1.exists)(json, 'closed_at') ? undefined : (new Date(json['closed_at'])),
        'twilioRoomSid': !(0, runtime_1.exists)(json, 'twilio_room_sid') ? undefined : json['twilio_room_sid'],
        'referenceId': !(0, runtime_1.exists)(json, 'reference_id') ? undefined : json['reference_id'],
        'participants': !(0, runtime_1.exists)(json, 'participants') ? undefined : (json['participants'].map(_1.StreemApiRoomParticipantFromJSON)),
        'companySid': !(0, runtime_1.exists)(json, 'company_sid') ? undefined : json['company_sid'],
        'videoPlatform': !(0, runtime_1.exists)(json, 'video_platform') ? undefined : json['video_platform'],
        'deleted': !(0, runtime_1.exists)(json, 'deleted') ? undefined : json['deleted'],
        'deletedAt': !(0, runtime_1.exists)(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
        'encryptedWallItems': !(0, runtime_1.exists)(json, 'encrypted_wall_items') ? undefined : json['encrypted_wall_items'],
        'wallPlatform': !(0, runtime_1.exists)(json, 'wall_platform') ? undefined : json['wall_platform'],
        'integrationId': !(0, runtime_1.exists)(json, 'integration_id') ? undefined : json['integration_id'],
        'details': !(0, runtime_1.exists)(json, 'details') ? undefined : (json['details'].map(_1.StreemApiRoomDetailFromJSON)),
        'reservationSid': !(0, runtime_1.exists)(json, 'reservation_sid') ? undefined : json['reservation_sid'],
        'roomInvitations': !(0, runtime_1.exists)(json, 'room_invitations') ? undefined : (json['room_invitations'].map(_1.StreemApiRoomInvitationFromJSON)),
        'chimeRoomSid': !(0, runtime_1.exists)(json, 'chime_room_sid') ? undefined : json['chime_room_sid'],
        'recordingStartedAt': !(0, runtime_1.exists)(json, 'recording_started_at') ? undefined : (new Date(json['recording_started_at'])),
        'callDuration': !(0, runtime_1.exists)(json, 'call_duration') ? undefined : (0, _1.GoogleProtobufDurationFromJSON)(json['call_duration']),
        'callDetail': !(0, runtime_1.exists)(json, 'call_detail') ? undefined : (0, _1.StreemApiCallDetailFromJSON)(json['call_detail']),
        'reservationGroup': !(0, runtime_1.exists)(json, 'reservation_group') ? undefined : (0, _1.StreemApiGroupFromJSON)(json['reservation_group']),
    };
}
exports.StreemApiRoomFromJSONTyped = StreemApiRoomFromJSONTyped;
function StreemApiRoomToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'created_by_user_sid': value.createdByUserSid,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'opened_at': value.openedAt === undefined ? undefined : (value.openedAt.toISOString()),
        'preferred_video_codec': value.preferredVideoCodec,
        'status': value.status,
        'closed_at': value.closedAt === undefined ? undefined : (value.closedAt.toISOString()),
        'twilio_room_sid': value.twilioRoomSid,
        'reference_id': value.referenceId,
        'participants': value.participants === undefined ? undefined : (value.participants.map(_1.StreemApiRoomParticipantToJSON)),
        'company_sid': value.companySid,
        'video_platform': value.videoPlatform,
        'deleted': value.deleted,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'encrypted_wall_items': value.encryptedWallItems,
        'wall_platform': value.wallPlatform,
        'integration_id': value.integrationId,
        'details': value.details === undefined ? undefined : (value.details.map(_1.StreemApiRoomDetailToJSON)),
        'reservation_sid': value.reservationSid,
        'room_invitations': value.roomInvitations === undefined ? undefined : (value.roomInvitations.map(_1.StreemApiRoomInvitationToJSON)),
        'chime_room_sid': value.chimeRoomSid,
        'recording_started_at': value.recordingStartedAt === undefined ? undefined : (value.recordingStartedAt.toISOString()),
        'call_duration': (0, _1.GoogleProtobufDurationToJSON)(value.callDuration),
        'call_detail': (0, _1.StreemApiCallDetailToJSON)(value.callDetail),
        'reservation_group': (0, _1.StreemApiGroupToJSON)(value.reservationGroup),
    };
}
exports.StreemApiRoomToJSON = StreemApiRoomToJSON;
/**
* @export
* @enum {string}
*/
var StreemApiRoomPreferredVideoCodec;
(function (StreemApiRoomPreferredVideoCodec) {
    StreemApiRoomPreferredVideoCodec["H264"] = "VIDEO_CODEC_H264";
    StreemApiRoomPreferredVideoCodec["VP8"] = "VIDEO_CODEC_VP8";
    StreemApiRoomPreferredVideoCodec["VP9"] = "VIDEO_CODEC_VP9";
    StreemApiRoomPreferredVideoCodec["INVALID"] = "VIDEO_CODEC_INVALID";
})(StreemApiRoomPreferredVideoCodec = exports.StreemApiRoomPreferredVideoCodec || (exports.StreemApiRoomPreferredVideoCodec = {}));
/**
* @export
* @enum {string}
*/
var StreemApiRoomStatus;
(function (StreemApiRoomStatus) {
    StreemApiRoomStatus["OPEN"] = "STATUS_OPEN";
    StreemApiRoomStatus["CLOSED"] = "STATUS_CLOSED";
    StreemApiRoomStatus["INVALID"] = "STATUS_INVALID";
})(StreemApiRoomStatus = exports.StreemApiRoomStatus || (exports.StreemApiRoomStatus = {}));
/**
* @export
* @enum {string}
*/
var StreemApiRoomVideoPlatform;
(function (StreemApiRoomVideoPlatform) {
    StreemApiRoomVideoPlatform["TWILIO"] = "VIDEO_PLATFORM_TWILIO";
    StreemApiRoomVideoPlatform["ARAAS"] = "VIDEO_PLATFORM_ARAAS";
    StreemApiRoomVideoPlatform["CHIME"] = "VIDEO_PLATFORM_CHIME";
    StreemApiRoomVideoPlatform["INVALID"] = "VIDEO_PLATFORM_INVALID";
})(StreemApiRoomVideoPlatform = exports.StreemApiRoomVideoPlatform || (exports.StreemApiRoomVideoPlatform = {}));
/**
* @export
* @enum {string}
*/
var StreemApiRoomWallPlatform;
(function (StreemApiRoomWallPlatform) {
    StreemApiRoomWallPlatform["TWILIO"] = "WALL_PLATFORM_TWILIO";
    StreemApiRoomWallPlatform["STREEM"] = "WALL_PLATFORM_STREEM";
    StreemApiRoomWallPlatform["INVALID"] = "WALL_PLATFORM_INVALID";
})(StreemApiRoomWallPlatform = exports.StreemApiRoomWallPlatform || (exports.StreemApiRoomWallPlatform = {}));
//# sourceMappingURL=StreemApiRoom.js.map